import commonFunction from "../../lib/utils/common";

import Footer1 from "./footer1";
import Footer2 from "./footer2";
import Footer4 from "./footer4";
import Footer5 from "./footer5";
import Footer7 from "./footer7";
import Footer8 from "./footer8";
import Footer9 from "./footer9";
import Footer10 from "./footer10";
import Footer11 from "./footer11";
import Footer12 from "./footer12";
import Footer13 from "./footer13";

export function Footer(props) {
  const { theme } = props;

  switch (theme) {
    case "theme1":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer1 data={props} />
      );
      break;
    case "theme2":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer2 data={props} />
      );
      break;
    case "theme4":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer4 data={props} />
      );
      break;
    case "theme5":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer5 data={props} />
      );
      break;
    case "theme7":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer7 data={props} />
      );
    case "theme8":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer8 data={props} />
      );
      break;
    case "theme9":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer9 data={props} />
      );
      break;
    case "theme10":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer10 data={props} />
      );
      break;
    case "theme11":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer11 data={props} />
      );
      break;
    case "theme12":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer12 data={props} />
      );
      break;
    case "theme13":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Footer13 data={props} />
      );
      break;
    default:
      return <Footer1 />;
  }
}

export default Footer;
